import { Component, OnInit } from '@angular/core';
import { MetaService } from '../../../services/meta-service.service';
@Component({
  selector: 'app-automated-gates',
  templateUrl: './automated-gates.component.html',
  styleUrls: ['./automated-gates.component.scss']
})
export class AutomatedGatesComponent implements OnInit {

  constructor(private metaService: MetaService) { }

  ngOnInit(): void {
    this.metaService.setCanonicalURL();
  }

}
